/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterChildDto } from '../../models/center-child-dto';

export interface AdminCenterChildControllerFindById$Params {
  id: string;
}

export function adminCenterChildControllerFindById(http: HttpClient, rootUrl: string, params: AdminCenterChildControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterChildDto>> {
  const rb = new RequestBuilder(rootUrl, adminCenterChildControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterChildDto>;
    })
  );
}

adminCenterChildControllerFindById.PATH = '/api/center-child/admin/{id}';
